<template>
	<div class="declaration-stat">
		<div style="margin-bottom: 20px;">
			<!-- <el-select v-model="form.projectId" placeholder="请选择" @change="changeProject">
				<el-option v-for="item in projectOptions" :key="item.id" :label="item.projectName" :value="item.id"></el-option>
			</el-select> -->
		</div>
		<el-row :gutter="20">
			<el-col :span="12"><div id="bar"></div></el-col>
			<el-col :span="12"><div id="pie"></div></el-col>
		</el-row>
		<div class="sum">
			{{getText}}
		</div>
		
	</div>
</template>

<script>
	import { getBarData, getPieData, getFontData, getEduProjectLsit } from '@/api/after/projectApplication.js'
export default {
	data() {
		return {
			form:{
				projectId:'',
			},
			projectOptions:[],
			projectData:{},
			barData:[],
			pieData:null,
			fontData:null,
		};
	},
	computed:{
		getText(){
			if (this.fontData) {
				let str = ''
				for(let i=0;i<this.fontData.size;i++){
					str += `，${this.fontData['name'+i]}：${this.fontData['number'+i]}个`
				}
				str += '。'
				return `课题申报总数：${this.fontData.totalNumber}个，高中课题：${this.fontData.higSchoolTotalNumber}个，初中课题：${this.fontData.juniorHighSchoolTotalNumber}个，小学课题：${this.fontData.primarySchoolTotalNumber}个，幼儿园课题：${this.fontData.kindergartenTotalNumber}个，高/中职课题：${this.fontData.technicalSecondarySchoolTotalNumber}个，其他课题：${this.fontData.otherTotalNumber}${str}`
			}
		}
	},
	async mounted() {
		let projectData=sessionStorage.getItem('projectData')
		if(projectData){
			this.projectData=JSON.parse(projectData)
			this.form.projectId = this.projectData.id;
		}else{
			this.$message({
				type:'error',
				message:'没有项目！',
				onClose:()=>{
					this.$router.go(-1)
				}
			})
		}
		await this.getBarData()
		await this.getPieData()
		await this.getFontData()
		this.initBarCharts(this.barData);
		this.initPie(this.pieData);
	},
	methods: {
		initBarCharts(arrData) {
			let echarts = this.$echarts.init(document.getElementById('bar'));
			if (arrData.length == 0) {
				return 
			}
			// 处理显示数据
			// 数据有多少种
			let dataSize = arrData[0].size
			let newArrData = []
			// 处理第一个数组数据
			let firstArr = ['product']
			for(let i = 0; i<dataSize; i++){
				firstArr.push(arrData[0]['name'+i])
			}
			newArrData.push(firstArr)
			// 处理其他行数组数据
			arrData.forEach((item,index) =>{
				let newArr = []
				newArr.push(item.typeName)
				for(let i = 0; i<dataSize; i++){
					newArr.push(item['number'+i])
				}
				newArrData.push(newArr)
			})
			console.log('处理好的柱状图数据',newArrData);
			// 处理柱状图根数数据
			let seriesArr = []
			for(let i=0; i<dataSize; i++){
				seriesArr.push({type:'bar'})
			}
			
			let option = {
				legend: {},
				tooltip: {},
				dataset: {
					source: newArrData
				},
				xAxis: { type: 'category' },
				yAxis: {},
				// Declare several bar series, each will be mapped
				// to a column of dataset.source by default.
				series: seriesArr
			};
			echarts.setOption(option);
		},
		initPie(objData) {
			let echarts = this.$echarts.init(document.getElementById('pie'));
			
			if ( objData.size == 0) {
				return 
			}
			// 处理显示数据
			// 数据有多少种
			let dataSize = objData.size
			let legendArr = []
			let newData = []
			for(let i = 0; i<dataSize; i++){
				legendArr.push(objData['name'+i])
				newData.push({
					value:objData['number' + i],
					name:objData['name'+ i],
				})
			}
			console.log('处理好的饼图数据',legendArr,newData);
			
			let option = {
				tooltip: {
					trigger: 'item',
					formatter: '{a} <br/>{b}: {c} ({d}%)'
				},
				legend: {
					orient: 'vertical',
					left: 10,
					data: legendArr
				},
				series: [
					{
						name: '访问来源',
						type: 'pie',
						radius: ['40%', '70%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: true,
								fontSize: '30',
								fontWeight: 'bold'
							}
						},
						labelLine: {
							show: false
						},
						data: newData
					}
				]
			};

			echarts.setOption(option);
		},
		// 改变项目
		changeProject(e){
			console.log(e);
			this.reloadData()
		},
		// 重新渲染页面
		async reloadData(){
			await this.getBarData()
			await this.getPieData()
			await this.getFontData()
			this.initBarCharts(this.barData);
			this.initPie(this.pieData);
		},
		// 获取项目列表
		async getEduProjectLsit() {
			const res = await getEduProjectLsit();
			if (res.code == 200) {
				this.projectOptions = res.data
			}
		},
		async getBarData(){
			const res = await getBarData(this.form.projectId)
			if(res.code==200){
				console.log('柱状图图表',res.data)
				this.barData = res.data
			}
		},
		async getPieData(){
			const res = await getPieData(this.form.projectId)
			if(res.code==200){
				console.log('饼图表',res)
				this.pieData = res.data
			}
		},
		async getFontData(){
			const res = await getFontData(this.form.projectId)
			if(res.code==200){
				console.log('文字',res)
				this.fontData = res.data
			}
		},
	}
};
</script>

<style scoped lang="scss">
#bar,
#pie {
	height: 500px;
	width: 500px;
}
</style>
